import { useUser } from '@poplar/hooks/useUser';
import { IntlProvider } from '@yoweb/next-i18next/IntlProvider';
import { useExternalConfig } from './ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export var PoplarIntlProvider = function PoplarIntlProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;
  var user = useUser();

  var _useExternalConfig = useExternalConfig(),
      fallbackI18nextInitOptions = _useExternalConfig.fallbackI18nextInitOptions;

  var i18nextInitOptions = value !== null && value !== void 0 ? value : fallbackI18nextInitOptions;
  return /*#__PURE__*/_jsx(IntlProvider, {
    value: i18nextInitOptions,
    timeZone: user.timeZone,
    children: children
  });
};